import gql from 'graphql-tag';

const REMOVE_ADDITIONAL_CHARACTERISTIC = gql`
  mutation removeAdditionalCharacteristic($characteristicId: ID) {
    removeAdditionalCharacteristic(characteristicId: $characteristicId)
  }
`;

export default REMOVE_ADDITIONAL_CHARACTERISTIC;
